import { useSelfieCanvas } from '@/components/slides/Selfie/useSelfieCanvas.ts';
import { ICONS } from '@/Icons.tsx';
import React, { FC } from 'react';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { translate } from '@/translation/translate.ts';
import { CustomOverlayNavigation } from '@/components/slides/Selfie/CustomOverlayNavigation.tsx';

interface SelfieOverlayProps {
  onClose: () => void;
}

export const SelfieOverlay: FC<SelfieOverlayProps> = ({ onClose }) => {
  const { currentSlide } = useNavigation();
  const {
    canvasRef,
    videoRef,
    parentRef,
    nextFrame,
    prevFrame,
    prevFrameSrc,
    nextFrameSrc,
    takeSnapshot,
    clearSnapshot,
    shareSnapshot,
    switchCamera,
    hasSnapshot,
    width,
    height,
    videoOffset,
    notAllowed,
    restartCamera,
    shareButtonWasClicked,
  } = useSelfieCanvas();

  const showControlButtons = width > 0 && height > 0;

  return (
    <div className={'overlay'} ref={parentRef}>
      <div className={'close-bar'}>
        <button data-cy={'close-overlay'} className="close" onClick={onClose}>
          <i className={ICONS.cancel} />
        </button>
      </div>

      <div className={'selfie-wrapper'}>
        <div
          className={'video-container'}
          style={{
            width: width,
            height: height,
          }}
        >
          <div className={'video-cropper'} style={{ width: width, height: height }}>
            <video
              playsInline
              ref={videoRef}
              style={{
                top: videoOffset.top,
                left: videoOffset.left,
              }}
              id={'selfie-video'}
            ></video>
          </div>

          <canvas width={width} height={height} ref={canvasRef} id={'selfie-canvas'} />
        </div>

        {showControlButtons && (
          <div
            className={'control-center'}
            style={{
              width: width,
              height: height,
            }}
          >
            <div className={'prev-frame'}>
              <button onClick={prevFrame}>
                <img src={prevFrameSrc} alt="Previous Filter" />
              </button>
            </div>
            {hasSnapshot && (
              <div className={'clear-snapshot'}>
                <button onClick={clearSnapshot}>
                  <i className={ICONS.cancel} />
                </button>
              </div>
            )}
            <div className={'share-snapshot'}>
              {hasSnapshot && (
                <button onClick={shareSnapshot}>
                  <i className={ICONS.shareSelfie} />
                </button>
              )}
            </div>
            <div className={'take-snapshot'}>
              {!hasSnapshot && (
                <button onClick={takeSnapshot}>
                  <i className={ICONS.takeSelfie} />
                </button>
              )}
            </div>
            <div className={'next-frame'}>
              <button onClick={nextFrame}>
                <img src={nextFrameSrc} alt="Next Filter" />
              </button>
            </div>

            <div className={'switch-camera'}>
              <button onClick={switchCamera}>
                <i className={ICONS.switchCamera} />
              </button>
            </div>
            <div className="socials">
              {currentSlide?.selfiehandle && <div className={'social-handle'}>{currentSlide?.selfiehandle}</div>}
              {currentSlide?.selfietag && <div className={'social-tag'}>{currentSlide?.selfietag}</div>}
            </div>

            {currentSlide?.selfieinfotext && (
              <div className={'info-text'}>{translate(currentSlide?.selfieinfotext)}</div>
            )}
          </div>
        )}
      </div>

      {notAllowed && (
        <div className={'pls-allow'}>
          <div className={'show-selfie-overlay'} onClick={restartCamera}>
            <br />
            {translate(currentSlide?.cameraDenied)}
          </div>
          <button className={'button'} onClick={restartCamera}>
            <i className={ICONS.selfie} /> &nbsp;
            {translate(currentSlide?.restartLabel)}
          </button>
        </div>
      )}
      {!notAllowed && !showControlButtons && (
        <div className={'pls-allow'}>
          <div className={'show-selfie-overlay'}>
            <i className={ICONS.spinner} />
            <br />
          </div>
        </div>
      )}
      <CustomOverlayNavigation shareButtonWasClicked={shareButtonWasClicked} />
    </div>
  );
};
